"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _getApolloRestClient = require("./getApolloRestClient");
var _logger = _interopRequireDefault(require("./logger"));
const QUERY = "\n  query navigation {\n    list @rest(path: \"\") {\n      credits\n      primary\n      services\n    }\n  }\n";
const fetchNavigationItems = async _ref => {
  let {
    locale,
    bffUrl
  } = _ref;
  const navItemRepositoryUrl = "".concat(bffUrl, "/navigation/?lang=").concat(locale, "&isExternal=true");
  const client = (0, _getApolloRestClient.getApolloRestClient)(navItemRepositoryUrl);
  const query = (0, _client.gql)(QUERY);
  return client.query({
    query,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }).then(response => {
    const {
      credits,
      primary = [],
      services = []
    } = response.data.list;
    if (primary.length === 0 || services.length === 0) {
      const stringifiedResponse = JSON.stringify(response);
      _logger.default.error('Error fetching shared header items', stringifiedResponse);
      throw new Error(stringifiedResponse);
    }
    return {
      credits,
      primary,
      services
    };
  }).catch(err => {
    _logger.default.error('Error fetching shared header items', err);
    throw err;
  });
};
var _default = exports.default = fetchNavigationItems;